import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { PageLoader } from '@/components/auth/PageLoader'

export default function RootRedirect() {
  const status = useAuthStore((s) => s.status)
  const memberships = useAuthStore((s) => s.memberships)
  const loadMe = useAuthStore((s) => s.loadMe)

  useEffect(() => {
    if (status === 'idle') void loadMe()
  }, [status, loadMe])

  if (status === 'idle' || status === 'loading') return <PageLoader />
  if (status !== 'authed') return <Navigate to="/login" replace />
  if (memberships.length === 0) return <Navigate to="/workspace/create" replace />
  return <Navigate to="/workspaces" replace />
}
